import React, { useEffect, useRef, useState } from 'react';
import { FaCalendarAlt, FaCode, FaUsers, FaTrophy } from 'react-icons/fa';
import './style.css';

const stats = [
  { Icon: FaCalendarAlt, value: '10+', label: 'Jahre Erfahrung' },
  { Icon: FaCode, value: '50+', label: 'Projekte' },
  { Icon: FaUsers, value: '30+', label: 'Zufriedene Kunden' },
  { Icon: FaTrophy, value: '100%', label: 'Leidenschaft' }
];

const AboutSection = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const sectionNode = sectionRef.current;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          entry.target.classList.add('visible');
        }
      },
      { threshold: 0.05 }
    );
    if (sectionNode) observer.observe(sectionNode);
    return () => {
      if (sectionNode) observer.unobserve(sectionNode);
    };
  }, []);

  return (
    <section id="about" className="about-section" ref={sectionRef}>
      <div className={`about-content ${isVisible ? 'visible' : ''}`}>
        <span className="about-label">Über mich</span>
        <h2 className="about-headline">
          Full Stack Java Entwickler mit Leidenschaft für robuste und skalierbare Systeme.
        </h2>
        <p className="about-lead-mobile">
          Full Stack Java Entwickler mit Fokus auf saubere Architektur, robuste APIs
          und wartbare Enterprise-Lösungen.
        </p>
        <p className="about-body">
          Als erfahrener Fullstack-Entwickler mit Schwerpunkt auf Java und Spring Boot
          begleite ich Projekte von der Architektur bis zum produktiven Betrieb. Ich lege
          Wert auf saubere Codebases, verständliche APIs und Lösungen, die Teams langfristig
          weiterentwickeln können – mit React, wenn das Frontend es erfordert.
        </p>

        <div className="about-stats">
          {stats.map(({ Icon, value, label }) => (
            <div key={label} className="about-stat">
              <span className="about-stat-icon" aria-hidden>
                <Icon />
              </span>
              <div className="about-stat-text">
                <strong>{value}</strong>
                <span>{label}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
